<template>
  <v-container class="center-content">
    <!-- <div>
      <v-layout column justify-center align-center>
      <v-flex shrink class="my-16">
        <v-img alt="Cellsmart Logo" class="shrink mr-2" contain src="@/assets/fullLogo.png" transition="scale-transition"
          width="250" />
      </v-flex>
    </v-layout>
    </div> -->
    <v-layout v-if="signUpSuccess" align-center fill-height>
     
      <v-card-text>
        <v-layout align-center justify-center column fill-height>
          <v-icon color="green" large>mdi-email</v-icon>
          <h2 class="mb-2">Verify Your Email</h2>
          <p>
            Thanks for signing up. Please check your email to continue your
            account set up.
          </p>
          <v-row>
            <v-col cols="12" align="center">
              <v-btn color="secondary" @click="resend">Resend Email</v-btn></v-col>
            <v-col cols="12" align="center">
              <v-btn color="warning" to="/backoffice/login">Already Verified</v-btn></v-col>
          </v-row>
        </v-layout>
      </v-card-text>
    </v-layout>

    <v-col align="center" class="fill-hight" v-else>
      <v-col>
        <v-img alt="Cellsmart Logo" class="shrink mr-2" contain src="../../../assets/fullLogo.png"
          transition="scale-transition" width="250" />
      </v-col>
      <v-col>
        <div class="font-weight-bold title">Create Account</div>
      </v-col>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field outlined dense :error-messages="firstNameErrors"
                  :hide-details="firstNameErrors.length === 0" label="First Name" v-model="user.firstName"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined dense label="Last Name" :error-messages="lastNameErrors"
                  :hide-details="lastNameErrors.length === 0" v-model="user.lastName"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined dense label="Email" :hide-details="emailErrors.length === 0"
                  :error-messages="emailErrors" v-model="user.email" class="pa-1"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined dense label="Password" :hide-details="passwordErrors.length === 0"
                  :error-messages="passwordErrors" v-model="user.password" type="password"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined dense label="Confirm Password" :hide-details="confirmPasswordErrors.length === 0"
                  :error-messages="confirmPasswordErrors" v-model="user.confirmPassword" type="password"
                  v-on:keyup.enter="submit"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-row>
          <v-col class="text-left">
            <v-btn text to="/backoffice/login" width="100">Log In</v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="text-right">
            <v-btn color="primary" width="100" dark @click="submit">Next</v-btn>
          </v-col>
        </v-row>
      </v-col>
      <!-- <v-col cols="12" sm="4"><v-btn rounded color="primary" block @click="checkLocationCode">
          Submit
        </v-btn></v-col>
      <v-col cols="12" sm="4">
        <v-btn text @click.stop="drawer = !drawer">
          Recent Locations
        </v-btn>
      </v-col> -->




    </v-col>


    
  </v-container>
</template>

<script>
import signUpService from "@/modules/Authentication/service.js";
const { validationMixin } = require("vuelidate");
const {
  required,
  minLength,
  email,
  sameAs,
} = require("vuelidate/lib/validators");

export default {
  data() {
    return {
      user: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        acceptedTerms: false,
        ReferralCode: null,
        confirmPassword: null,
        plan: null,
        forceVerify: false,
        cciUser: true,
        isSuperAdmin: true
      },
      viewTerms: false,
      signUpSuccess: false,
    };
  },
  computed: {
    firstNameErrors() {
      const errors = [];
      if (!this.$v.user.firstName.$dirty) return errors;
      if (!this.$v.user.firstName.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.user.firstName.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast2ChrLong"));
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.user.lastName.$dirty) return errors;
      if (!this.$v.user.lastName.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast2ChrLong"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.user.email.$dirty) return errors;
      if (!this.$v.user.email.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.user.email.email)
        errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.user.password.$dirty) return errors;
      if (!this.$v.user.password.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.user.password.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.user.confirmPassword.$dirty) return errors;
      if (!this.$v.user.confirmPassword.sameAsPassword)
        errors.push(this.$t("validations.passwordDoesNotMatch"));
      return errors;
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        // this.$swal
        //       .mixin({
        //         toast: true,
        //         showConfirmButton: true,
        //         position: 'top-end',
        //         timer: 3000,
        //       })
        //       .fire({
        //         type: 'error',
        //         title: this.$t('toastMessage.text.missingFields'),
        //       });
        this.$toast.error(this.$t('toastMessage.text.missingFields'), {
          timeout: 2000,
        });
      } else {
        // this.$router.push({
        //   name: "newOrganization",
        //   params: { email: this.user.email },
        // });
        signUpService
          .submit(this.user)
          .then((response) => {
            console.log("User created", response);
            if (this.$route.query.plan || this.user.forceVerify) {
              this.$toast.success("User created.", {
                timeout: 3500,
              });
              this.$router.push({
                name: "newOrganization",
                params: { email: this.user.email },
              });
              // this.$router.push({
              //   name: "newOrganization",
              //   params: { plan: this.$route.query.plan, email: this.user.email},
              // });
            } else {
              this.signUpSuccess = true;
            }
          })
          .catch((error) => {
            console.log("test", error);
            this.$toast.error(error.data.message, {
              timeout: 3500,
            });
          });
      }
    },
    resend() {
      console.log(this.user.email);
      signUpService
        .resendVerifyEmail({ email: this.user.email, cciUser: true })
        .then((response) => {
          console.log(response.data);
          this.$toast.success(`Resent Email to ${this.user.email}`, {
            timeout: 2000,
          });
        })
        .catch((error) => {
          this.$Progress.finish();
          this.isLoading = false;
          this.error = true;
          this.errorMessage = error.data.message;
        });
    },
  },
  mixins: [validationMixin],
  validations: {
    user: {
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        minLength: minLength(1),
      },
      email: {
        email,
        required,
      },
      password: {
        required,
        minLength: minLength(4),
      },
      confirmPassword: {
        sameAsPassword: sameAs("password"),
      },
    },
  },
};
</script>

<style scoped>

</style>